import CookiesKeys, { cookieStorage } from "./cookies";

export const getToken = (): string | null => {
  return localStorage.getItem(CookiesKeys.TokenKey);
};

export const login = (token: string) => {
  localStorage.setItem(CookiesKeys.TokenKey, token);
};

export const logout = () => {
  localStorage.removeItem(CookiesKeys.TokenKey);
  removeloginCookie();
  window.location.reload();
};

export const getTokenCookie = (): string | null => {
  return cookieStorage.getItem(CookiesKeys.TokenKey);
};

export const loginCookie = (token: string) => {
  cookieStorage.setItem(CookiesKeys.TokenKey, token);
};
//AQUI SE GUARA LA VARIABLE QUE SE UTILIZA EN EL MAESTRO DEL CSS PARA PERSONALIZAR MODULOS COMO EL DE CHUBB EN EVENTOS
export const styleCookie = (token: string) => {
  cookieStorage.setItem(CookiesKeys.StyleKey, token);
};
export const getStyleCookie = (): string | null => {
  return cookieStorage.getItem(CookiesKeys.StyleKey);
};

export const removeloginCookie = () => {
  cookieStorage.removeItem(CookiesKeys.TokenKey);
};

export const isAuthenticated = () => {
  
  const accessToken = cookieStorage.getItem("tokenKey");
  if(accessToken){
    return true;
  }
  const localaccessToken = getToken();
  if(localaccessToken){
    return true;
  }
  return false;
};

